import { timelineEra } from "@/mocks/archive";

export default function ArchiveTimeline() {
  return (
    <section id="timeline" className="bg-background-50 border-t border-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="text-center max-w-2xl mx-auto">
          <p className="inline-flex items-center gap-2 text-sm font-medium text-accent-700">
            <i className="ri-history-line" />
            年代编年
          </p>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            旧料的形态如何随时代变化
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            从 BBS 到短视频，全网黑料旧料的存证与考古方式也在不断迭代。按年代梳理早期黑历史与历史遗留的载体变迁。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {timelineEra.map((e, i) => (
            <div
              key={e.era}
              className="relative rounded-lg border border-background-200 bg-background-100 p-6"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                  <i className="ri-time-line text-lg" />
                </span>
                <span className="font-heading text-4xl font-bold text-background-300">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <p className="mt-5 font-heading text-lg font-bold text-foreground-950">{e.era}</p>
              <span className="mt-1 inline-block rounded-full bg-secondary-200 px-2.5 py-0.5 text-xs font-medium text-secondary-900 whitespace-nowrap">
                {e.tag}
              </span>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{e.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}